import {ERROR, PENDING, SUCCESS} from '@travel-frontend/state-handling-sdk';

import keywordApi from '@/api/keywordApi';
import {FETCH_KEYWORD_DATA} from '@/redux/v1/keywordData/models';
import {
  selectDataById,
  selectErrorById,
  selectStatusById,
} from '@/redux/v1/keywordData/reducer';

// @ts-expect-error ...
const successfulResponse = (data) => ({
  status: 'successful',
  data,
  error: null,
});

// @ts-expect-error ...
const failedResponse = (error) => ({
  status: 'failed',
  data: null,
  error,
});

const fetchKeywordDataImplementation = async (keywordId: string) => {
  try {
    const response = await keywordApi.keywordsById(keywordId);
    if (
      !response.data ||
      ('code' in response.data && 'message' in response.data)
    ) {
      return failedResponse(new Error(response.data?.message));
    }
    return successfulResponse(response.data);
  } catch (error) {
    return failedResponse(error);
  }
};

const requests = {};

export const fetchKeywordData = (keywordId: string) => {
  // @ts-expect-error ...
  return async (dispatch, getState) => {
    const status = selectStatusById(keywordId, getState());

    if (status === 'successful') {
      return successfulResponse(selectDataById(keywordId, getState()));
    }
    if (status === 'failed') {
      return failedResponse(selectErrorById(keywordId, getState()));
    }
    if (status === 'loading') {
      // @ts-expect-error ...
      return requests[keywordId];
    }

    dispatch({
      type: PENDING(FETCH_KEYWORD_DATA),
      meta: {keywordId},
    });

    // @ts-expect-error ...
    requests[keywordId] = fetchKeywordDataImplementation(keywordId);
    // @ts-expect-error ...
    const keywordData = await requests[keywordId];

    if (keywordData.status === 'successful') {
      dispatch({
        type: SUCCESS(FETCH_KEYWORD_DATA),
        payload: keywordData.data,
        meta: {keywordId},
      });
    } else {
      dispatch({
        type: ERROR(FETCH_KEYWORD_DATA),
        error: keywordData.error,
        meta: {keywordId},
      });
    }

    return keywordData;
  };
};
